/**
 * The app's navigation, in one place. `Layout` renders it and `App` mounts a
 * route per entry, so the two cannot disagree; routing.test.tsx pins that.
 *
 * Four tabs (mockup round 2, 2026-09-11). People is setup, so it sits behind
 * the header icon instead of taking a tab.
 */
export type NavIcon = "shows" | "upcoming" | "roster" | "stats";

export interface NavEntry {
  to: string;
  label: string;
  icon: NavIcon;
}

export const NAV: readonly NavEntry[] = [
  { to: "/", label: "Shows", icon: "shows" },
  { to: "/upcoming", label: "Upcoming", icon: "upcoming" },
  { to: "/bands", label: "Bands & venues", icon: "roster" },
  { to: "/stats", label: "Stats", icon: "stats" },
];
